import React from 'react';
import CommonModalLayout from '../../form-components/CommonModalLayout';
import CommonModalButton from '../../form-components/CommonModalButton';
import { CompareCard, CompareHeading, CompareLine, NoticeItem, NoticeList } from './MemberAppLinkStyled';

const toDay = value => (value ? String(value).slice(0, 10) : '-');

/**
 * 대기 요청 거절 — 요청한 앱 계정을 보여주고, 거절하면 회원에게 무엇이 가는지 안내한다.
 * 거절해도 회원은 앱에서 다시 요청할 수 있다(대기 중 요청만 중복 차단).
 */
const RejectLinkModal = ({ open, onClose, onConfirm, link, isLoading }) => {
  if (!link) return null;
  return (
    <CommonModalLayout
      open={open}
      // 요청 중에는 Esc·바깥 클릭으로 닫히지 않게
      onClose={isLoading ? undefined : onClose}
      disableEscapeKeyDown={isLoading}
      title="연동 요청 거절"
      description="이 앱 계정의 센터 연동 요청을 거절합니다."
      width={480}
      footer={
        <>
          <CommonModalButton variant="cancel" onClick={onClose} disabled={isLoading}>
            취소
          </CommonModalButton>
          <CommonModalButton variant="delete" onClick={onConfirm} disabled={isLoading}>
            거절
          </CommonModalButton>
        </>
      }>
      <CompareCard>
        <CompareHeading>요청한 앱 계정</CompareHeading>
        <CompareLine>이름 {link.appAccount?.name || '-'}</CompareLine>
        <CompareLine>아이디 {link.appAccount?.username || '-'}</CompareLine>
        <CompareLine>번호 {link.appAccount?.phoneNumber || '-'}</CompareLine>
        <CompareLine>요청일 {toDay(link.registeredDate)}</CompareLine>
      </CompareCard>
      <NoticeList>
        <NoticeItem>회원 앱으로 거절 알림이 갑니다.</NoticeItem>
        <NoticeItem>회원은 나중에 앱에서 다시 연동을 요청할 수 있습니다.</NoticeItem>
        <NoticeItem>같은 사람이 센터에 있다면 거절 대신 [승인]에서 그 회원을 골라 연결해 주세요.</NoticeItem>
      </NoticeList>
    </CommonModalLayout>
  );
};

export default RejectLinkModal;
